import { useViewport } from 'contexts/viewport';
import { useTranslation } from 'react-i18next';
import { Box, Button, Form, Stack, styled, Text, TextInput } from 'shell/components';

const NameInputs = ({ form, errors, handleChange, handleNext }) => {
    const { device } = useViewport();
    const { t } = useTranslation();

    return (
        <RootBox device={device}>
            <Stack sx={{ mb: 6 }} alignItems={'center'} spacing={1}>
                <Text component={'h1'} variant={'h6'} weight={'medium'}>
                    {t('account-settings.setup-title', 'Welcome to TimelyGrader!')}
                </Text>
                <Text variant={'p1'} align={'center'}>
                    {t(
                        'account-settings.setup-description',
                        'Please add the following details to set up your profile.'
                    )}
                </Text>
            </Stack>
            <Form onSubmit={handleNext}>
                <InputStack spacing={4}>
                    <Stack direction={device === 'desktop' ? 'row' : 'column'} spacing={4}>
                        <TextInput
                            data-cy={'account-creation-firstname'}
                            error={Boolean(errors.firstName)}
                            helperText={errors.firstName}
                            label={t('account-settings.profile.first-name', 'First Name')}
                            placeholder={t('account-settings.profile.enter-first-name', 'Enter your first name')}
                            required
                            value={form.firstName}
                            onChange={(e) => handleChange('firstName', e.target.value)}
                        />
                        <TextInput
                            data-cy={'account-creation-lastname'}
                            error={Boolean(errors.lastName)}
                            helperText={errors.lastName}
                            label={t('account-settings.profile.last-name', 'Last Name')}
                            placeholder={t('account-settings.profile.enter-last-name', 'Enter your last name')}
                            required
                            value={form.lastName}
                            onChange={(e) => handleChange('lastName', e.target.value)}
                        />
                    </Stack>
                    <Stack>
                        <TextInput
                            error={Boolean(errors.preferredName)}
                            helperText={errors.preferredName}
                            label={t('account-settings.profile.preferred-name', 'Preferred Name')}
                            value={form.preferredName}
                            placeholder={t('account-settings.profile.enter-name', 'Enter name')}
                            onChange={(e) => handleChange('preferredName', e.target.value)}
                        />
                    </Stack>
                </InputStack>
                <ButtonStack direction={'row-reverse'} justifyContent={'space-between'}>
                    <Button data-cy={'account-creation-next-button'} type={'submit'}>
                        {t('controls.next', 'Next')}
                    </Button>
                </ButtonStack>
            </Form>
        </RootBox>
    );
};

const RootBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: device === 'mobile' ? 0 : theme.spacing(7),
        width: device === 'mobile' ? '100%' : 450,
        height: 'fit-content',
        background: device === 'mobile' ? 'transparent' : theme.palette.ensightful.shades[0],
        boxShadow: device === 'mobile' ? 'none' : theme.palette.ensightful.shadows[1],
        borderRadius: '12px',
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
    };
});

const ButtonStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 3, 0),
    };
});

export default NameInputs;
